import { useLocale } from 'locale';
import React from 'react';
import * as Styled from '../private/styled';
import { PoiId } from 'utils/entities';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';
import { DeveloperContactProps } from 'components/contact/types';
import { ContactAgentModalSource, ContactModalOpenMeta } from 'store/state/app';
import { useScreenBreakpoint } from 'consts/breakpoints';
import ContactButtons from 'components/contact-buttons';
import _ from 'lodash';
import { DeveloperLogo } from 'components/contact/DeveloperLogo';
import { Developers } from 'components/contact/Developers';

interface POIGalleryDeveloperStickyProps extends DeveloperContactProps {
  id: PoiId;
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => void;
  onCallClickEvent?: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
}

export const POIGalleryDeveloperSticky: React.FC<POIGalleryDeveloperStickyProps> = (props) => {
  const {
    onCallClickEvent,
    contactValues,
    onSetContactModalPoiId,
    phone,
    poiType,
    id,
    isContacted,
    projectName,
    projectLogo,
    developers,
    isPromoted,
  } = props;

  const { t } = useLocale();
  const screenBreakpoint = useScreenBreakpoint();
  const isMobile = screenBreakpoint < 3;
  const [ phoneNumberIsVisible, setPhoneNumberIsVisible ] = React.useState(false);

  const handleModalOpen = () => {
    onSetContactModalPoiId(id, { source: ContactAgentModalSource.AllGalleryList });
  };

  const handlePhoneSubmit = (e: React.MouseEvent<HTMLElement>) => {
    onCallClickEvent(isMobile || phoneNumberIsVisible, { ...contactValues, id, type: poiType }, ContactAgentModalSource.AllGalleryList);

    if (!phoneNumberIsVisible && !isMobile) {
      e.preventDefault();
      setPhoneNumberIsVisible(true);
    }
  };

  if (isMobile) {
    return (
      <Styled.Root data-auto="developer-gallery-poi-sticky">
        <ContactButtons
          phone={isPromoted ? phone : undefined}
          onShowPhone={handlePhoneSubmit}
          isContacted={isContacted}
          handleModalOpen={handleModalOpen}
          showPhone={phoneNumberIsVisible}
          dataAttributePrefix="developer-contact-poi"
          phoneButtonLabel={t('contactAgentModal.callButton')}
          mailButtonLabel={t('contactAgentStickyBar.contactAgentForm.open.alternative')}
          equalWidthButtons
          source={ContactAgentModalSource.AllGalleryList}
        />
      </Styled.Root>
    );
  }

  const formattedProjectName = t('projectPage.project.name', { name: projectName, isNotPromoted: !isPromoted });

  return (
    <Styled.Root data-auto="developer-gallery-poi-sticky" modeB>
      <Styled.InfoBox>
        <DeveloperLogo developerLogo={isPromoted ? projectLogo : undefined} size={56} />
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Styled.UserName weight="bold">{formattedProjectName}</Styled.UserName>
          <Developers developers={developers} />
        </div>
      </Styled.InfoBox>
      <ContactButtons
        phone={isPromoted ? phone : undefined}
        onShowPhone={handlePhoneSubmit}
        isContacted={isContacted}
        handleModalOpen={handleModalOpen}
        showPhone={phoneNumberIsVisible}
        dataAttributePrefix="developer-gallery-poi-sticky"
        mailButtonLabel={t('contactAgentStickyBar.contactAgentForm.open.alternative')}
        source={ContactAgentModalSource.AllGalleryList}
      />
    </Styled.Root>
  );
};
